module.exports = __webpack_public_path__ + "static/media/people-group.b312ce0e.jpg";